/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PairDeviceRequest as DigiworkMaitreDDtoPairDeviceRequest } from '../../models/Digiwork/MaitreD/DTO/pair-device-request';

export interface PairDevice$Params {
      body?: DigiworkMaitreDDtoPairDeviceRequest
}

export function pairDevice(http: HttpClient, rootUrl: string, params?: PairDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pairDevice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

pairDevice.PATH = '/api/pos/OrderBill/pairdevice';
